module.exports = __webpack_public_path__ + "static/turquia-029.thumb-8bb85c714b770c33eeb44acc7e5676ae.jpg";